import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Building, CreditCard, FileText, Upload, CheckCircle2, Camera } from 'lucide-react';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function VendorKYCScreen() {
  const {
    goBack
  } = useNavigation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      goBack();
    }, 2000);
  };
  if (isSubmitted) {
    return <div className="min-h-full bg-white dark:bg-gray-900 flex flex-col items-center justify-center p-6" data-id="element-1948">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} className="w-24 h-24 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-6" data-id="element-1949">
          <CheckCircle2 className="w-12 h-12 text-green-600 dark:text-green-400" data-id="element-1950" />
        </motion.div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-1951">
          KYC Submitted
        </h2>
        <p className="text-center text-gray-500 dark:text-gray-400" data-id="element-1952">
          Your documents have been submitted for review. We will notify you once
          the verification is complete.
        </p>
      </div>;
  }
  return <div className="min-h-full bg-gray-50 dark:bg-gray-900 pb-10" data-id="element-1953">
      <Header title="KYC Registration" showBack data-id="element-1954" />

      <form onSubmit={handleSubmit} className="p-4 space-y-6" data-id="element-1955">
        {/* Business Info */}
        <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700" data-id="element-1956">
          <div className="flex items-center gap-2 mb-4" data-id="element-1957">
            <Building className="w-5 h-5 text-primary" data-id="element-1958" />
            <h3 className="font-semibold text-gray-900 dark:text-white" data-id="element-1959">
              Business Information
            </h3>
          </div>
          <div className="space-y-4" data-id="element-1960">
            <div data-id="element-1961">
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-1962">
                Business Name
              </label>
              <input type="text" required className="w-full p-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary dark:text-white" placeholder="Registered Business Name" data-id="element-1963" />
            </div>
            <div data-id="element-1964">
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-1965">
                CAC Registration Number
              </label>
              <input type="text" required className="w-full p-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary dark:text-white" placeholder="RC Number" data-id="element-1966" />
            </div>
            <div data-id="element-1967">
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-1968">
                Business Address
              </label>
              <textarea required rows={2} className="w-full p-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary dark:text-white" placeholder="Full Address" data-id="element-1969"></textarea>
            </div>
          </div>
        </div>

        {/* Identity Verification */}
        <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700" data-id="element-1970">
          <div className="flex items-center gap-2 mb-4" data-id="element-1971">
            <FileText className="w-5 h-5 text-primary" data-id="element-1972" />
            <h3 className="font-semibold text-gray-900 dark:text-white" data-id="element-1973">
              Identity Verification
            </h3>
          </div>
          <div className="space-y-4" data-id="element-1974">
            <div data-id="element-1975">
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-1976">
                ID Type
              </label>
              <select className="w-full p-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary dark:text-white" data-id="element-1977">
                <option data-id="element-1978">National ID (NIN)</option>
                <option data-id="element-1979">Driver's License</option>
                <option data-id="element-1980">International Passport</option>
                <option data-id="element-1981">Voter's Card</option>
              </select>
            </div>
            <div data-id="element-1982">
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-1983">
                ID Number
              </label>
              <input type="text" required className="w-full p-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary dark:text-white" placeholder="Enter ID Number" data-id="element-1984" />
            </div>
            <div className="grid grid-cols-2 gap-3" data-id="element-1985">
              <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-4 flex flex-col items-center justify-center text-center cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1986">
                <Camera className="w-6 h-6 text-gray-400 mb-2" data-id="element-1987" />
                <span className="text-xs font-medium text-gray-600 dark:text-gray-300" data-id="element-1988">
                  Upload Front
                </span>
              </div>
              <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-4 flex flex-col items-center justify-center text-center cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1989">
                <Camera className="w-6 h-6 text-gray-400 mb-2" data-id="element-1990" />
                <span className="text-xs font-medium text-gray-600 dark:text-gray-300" data-id="element-1991">
                  Upload Back
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bank Info */}
        <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700" data-id="element-1992">
          <div className="flex items-center gap-2 mb-4" data-id="element-1993">
            <CreditCard className="w-5 h-5 text-primary" data-id="element-1994" />
            <h3 className="font-semibold text-gray-900 dark:text-white" data-id="element-1995">
              Bank Information
            </h3>
          </div>
          <div className="space-y-4" data-id="element-1996">
            <div data-id="element-1997">
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-1998">
                Bank Name
              </label>
              <select className="w-full p-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary dark:text-white" data-id="element-1999">
                <option data-id="element-2000">First Bank of Nigeria</option>
                <option data-id="element-2001">Guaranty Trust Bank</option>
                <option data-id="element-2002">Zenith Bank</option>
                <option data-id="element-2003">Access Bank</option>
              </select>
            </div>
            <div data-id="element-2004">
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-2005">
                Account Number
              </label>
              <input type="text" required maxLength={10} className="w-full p-3 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary dark:text-white" placeholder="10-digit account number" data-id="element-2006" />
            </div>
          </div>
        </div>

        <Button type="submit" className="w-full bg-primary hover:bg-primary/90 text-white py-4 rounded-xl font-semibold" data-id="element-2007">
          Submit KYC
        </Button>
      </form>
    </div>;
}